const Status = {
  CREATED: 'created',
  RISK_ASSESSMENT_APPROVED: 'risk_assessment_approved',
  RISK_ASSESSMENT_DECLINED: 'risk_assessment_declined',
  RISK_ASSESSMENT_REQUESTED: 'risk_assessment_requested',
  RISK_ASSESSMENT_REQUEST_FAILED: 'risk_assessment_request_failed',
  RISK_ASSESSMENT_REQUEST_EXPIRED: 'risk_assessment_request_expired',
  RISK_ASSESSMENT_MANUAL_REVIEW: 'risk_assessment_manual_review',
  AUTHENTICATION_ATTEMPTED: 'authentication_attempted',
  AUTHENTICATION_DECLINED: 'authentication_declined',
  AUTHENTICATION_REQUEST_FAILED: 'authentication_request_failed',
  AUTHENTICATION_REQUEST_EXPIRED: 'authentication_request_expired',
  AUTHENTICATION_REQUESTED: 'authentication_requested',
  AUTHENTICATION_SUCCESSFUL: 'authentication_successful',
  AUTHORIZATION_CANCEL_DECLINED: 'authorization_cancel_declined',
  AUTHORIZATION_CANCEL_REQUEST_FAILED: 'authorization_cancel_request_failed',
  AUTHORIZATION_CANCEL_REQUESTED: 'authorization_cancel_requested',
  AUTHORIZATION_CANCEL_SUCCESSFUL: 'authorization_cancel_successful',
  AUTHORIZATION_DECLINED: 'authorization_declined',
  AUTHORIZATION_EXPIRED: 'authorization_expired',
  AUTHORIZATION_RENEWED: 'authorization_renewed',
  AUTHORIZATION_FAILED: 'authorization_failed', // TODO : remove when not used
  AUTHORIZATION_REQUEST_FAILED: 'authorization_request_failed',
  AUTHORIZATION_REQUEST_EXPIRED: 'authorization_request_expired',
  AUTHORIZATION_REQUESTED: 'authorization_requested',
  AUTHORIZATION_SUCCESSFUL: 'authorization_successful',
  CAPTURE_DECLINED: 'capture_declined',
  CAPTURE_REQUEST_FAILED: 'capture_request_failed',
  CAPTURE_REQUESTED: 'capture_requested',
  CAPTURE_SUCCESSFUL: 'capture_successful',
  CREDIT_DECLINED: 'credit_declined',
  CREDIT_REQUEST_FAILED: 'credit_request_failed',
  CREDIT_REQUESTED: 'credit_requested',
  CREDIT_SUCCESSFUL: 'credit_successful',
  REFUND_DECLINED: 'refund_declined',
  REFUND_REQUEST_FAILED: 'refund_request_failed',
  REFUND_REQUESTED: 'refund_requested',
  REFUND_SUCCESSFUL: 'refund_successful',
  PAID: 'paid',
  CHARGED_BACK: 'charged_back',
  BLOCKED_BY_ROUTER: 'blocked_by_router',
  ROUTE_NOT_FOUND: 'route_not_found',
};

module.exports = Status;
